(function ($) {
	// on dom ready
	// check to see if any links in the main nav match the current url
	const navLinks = document.querySelectorAll('.main-nav a');
	// const currentUrl = window.location.href;

	// use the second link in the breadcrumbs for the current url - if there is a second link
	const $breadcrumbs = $('.breadcrumbs');
	const $firstLink = $breadcrumbs.find('li:nth-child(2) a');
	const currentUrl = $firstLink.length ? $firstLink.attr('href') : window.location.href;

	// change the currentURL to ignore GET params
	const currentUrlWithoutParams = currentUrl.split('?')[0];

	navLinks.forEach((link) => {
		const linkURL = link.href.split('?')[0];

		if (linkURL === currentUrlWithoutParams) {
			// find closest sub-menu
			const $link = $(link);
			// $parent.addClass('current_page_item');
			$link.addClass('current_page_item');
			$link.closest('.main-nav > li.menu-item').addClass('current_page_item');
		}
	});
})(jQuery);

// (function () {
// 	const toggle = document.querySelector('#toggle');
// 	const $target = document.querySelector('.main-nav-container');

// 	toggle.addEventListener('mousedown', function () {
// 		const isExpanded = this.getAttribute('aria-expanded') === 'true';

// 		this.setAttribute('aria-expanded', !isExpanded);
// 	});
// })();

(function ($) {
	const $toggle = $('#toggle');
	const $target = $('.navs-wrap');
	const $navScroll = $('.navs-wrap');
	const $header = $('.main-header');

	$toggle.on('click', function () {
		const isExpanded = this.getAttribute('aria-expanded') === 'true';

		this.setAttribute('aria-expanded', !isExpanded);

		if (isExpanded) {
			collapseNav();
		} else {
			expandNav();
		}
	});

	function expandNav() {
		$toggle.attr('aria-expanded', true);
		$header.addClass('expanded');
		$target.addClass('expanded');
		bodyScrollLock.disableBodyScroll($navScroll[0]);
	}

	function collapseNav() {
		$toggle.attr('aria-expanded', false);
		$header.removeClass('expanded');
		$target.removeClass('expanded');
		bodyScrollLock.enableBodyScroll($navScroll[0]);
	}
})(jQuery);
